<template>
  <a-upload v-bind="$attrs" v-on="$listeners" :headers="headers" :accept="accept" :before-upload="beforeUpload"
    :show-upload-list="showUploadList">
    <slot></slot>
  </a-upload>
</template>
<script>
import { xsrfHeaderName } from "@/utils/request";
import { getToken } from "@/utils/auth";
export default {
  name: "CUpload",
  props: {
    acceptType: {
      type: String,
      default: "img",
    },
    showUploadList: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  },
  data() {
    return {
      headers: {
        [xsrfHeaderName]: getToken(),
      },
    };
  },
  methods: {
    beforeUpload(file) {
      console.log(file);
      if (this.acceptType === "img") {
        const isJpgOrPng =
          file.type === "image/jpeg" || file.type === "image/png";
        if (!isJpgOrPng) {
          this.$message.error("仅支持上传图片!");
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          this.$message.error("最大 2MB!");
        }

        return isJpgOrPng && isLt2M;
      } else if (this.acceptType === "excel") {
        const isExcel =
          file.type === "application/vnd.ms-excel" ||
          file.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
          file.type == "application/wps-office.xlsx";
        if (!isExcel) {
          this.$message.error("仅支持上传excel文件!");
        }
        const isLt30M = file.size / 1024 / 1024 < 31;
        if (!isLt30M) {
          this.$message.error("最大 30MB!");
        }
        return isLt30M && isExcel;
      } else {
        const isLt30M = file.size / 1024 / 1024 < 31;
        if (!isLt30M) {
          this.$message.error("最大 30MB!");
        }
        const isNotJsOrHtml =
          file.type.indexOf("text/javascript") === -1 && file.type.indexOf("html") === -1;
        if (!isNotJsOrHtml) {
          this.$message.error("禁止上传js或html文件!");
        }
        return isLt30M && isNotJsOrHtml;
      }
    },
  },
  computed: {
    accept() {
      return this.acceptType === "img"
        ? "image/*"
        : this.acceptType == "excel"
          ? ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          : "*/*";
    },
  },
};
</script>